<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('feedback.detail')"
      :icon="'icon-charge-detail'"
      @close="closeDialog"
    />
    <vue-linetitle
      :title="$t('feedback.title')"
      :icon-config="{icon: 'car2-no'}"
    >
      <div class="title-line">
        <p style="display:flex;">
          <i>{{ $t('feedback.questions') }}：</i>
          <span style="flex:1">{{ titleData.feedbackMessage }}</span>
        </p>
        <p style="display:flex;">
          <i>{{ $t('feedback.submittime') }}：</i>
          <span style="flex:1">{{ titleData.createdOn }}</span>
        </p>
      </div>
    <div class="demo-image-preview">
      <el-image 
        style="width: 80px; height: 80px;margin-left:20px;"
        v-for="(item, index) in srcList"
        :key="index"
        :src="item" 
        :preview-src-list="srcList">
      </el-image>
    </div>
    </vue-linetitle>
    <vue-linetitle
      :title="$t('feedback.detail')"
      :icon-config="{icon: 'car-other'}"
    >
      <div class="timeline-block" style="height:40vh;">
        <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
          <el-timeline :reverse="true">
            <el-timeline-item
              v-for="(activity, index) in contentList"
              :key="index"
              :icon="activity.icon"
              :type="activity.type"
              :color="activity.color"
              :size="activity.size"
              :timestamp="activity.createdOn">
              {{activity.feedbackMessage}}
            </el-timeline-item>
          </el-timeline>
        </el-scrollbar>
      </div>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer" v-if="data.feedbackStatus === 0">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleReply">{{ $t('feedback.reply') }}</el-button>
    </span>
    <!-- 回复dialog弹窗 -->
    <reply-dialog
      :visibles.sync="replyVisible"
      :data="row"
      @reply-complete="addComplete"
    />
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { viewData } from '@/api/userCenter/feedback'
import replyDialog from './replyDialog'

export default {
  name: 'detailDialog',
  components: { replyDialog },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      row:{},
      replyVisible:false,
      contentList:[],  //内容
      titleData:{}, //标题
      srcList:[],//大图
      // srcList: [
      //     'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      //     'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      //   ]
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.getdetailData()
      }
    }
  },
  created() {
  },
  methods: {
    // 关闭
    closeDialog() {
      this.contentList = []
      this.srcList = []
      this.titleData = {}
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 获取数据
    getdetailData() {
      this.contentList = []
      this.srcList = []
      this.titleData = {}
      viewData({feedbackId: this.data.id}).then(({ data }) => {
        if (data.code === 0 && data.data) {
          this.titleData = data.data[0]
          this.srcList = data.data[0].images || []
          data.data.forEach(item => {
            if(item.feedbackMessageType === 2){
              item.icon = 'el-icon-answer'
              item.color = '#0bbd87'
            }else if(item.feedbackMessageType === 3){
              item.icon = 'el-icon-questions'
              item.color = '#FF0000'
            }
            item.size = 'large '
            if(item.feedbackMessageType != 1){
              this.contentList.push(item)
            }
          })
        }
      })
    },
    //回复
    handleReply(){
      this.row = {feedbackId: this.data.id}
      this.replyVisible = true
    },
    // 回复成功
    addComplete() {
      this.getdetailData()
    },
  }
}
</script>

<style  lang="scss">
.title-line{
  line-height:20px;
  i{
    width:90px;
    font-style:normal;
    text-align:right;
  }
}
.el-icon-answer:before {
  content: "A";
}
.el-icon-questions:before {
  content: "Q";
}
.timeline-block .el-timeline-item__node{
    left: -8px!important;
    width: 24px!important;
    height: 24px!important;
}
.timeline-block .el-timeline{
  padding-top:10px;
  padding-bottom:10px;
}
.demo-image-preview .el-icon-circle-close:before{
  color:#fff;
  font-size:30px;
}
</style>
